<template>
  <dx-popup
    v-model:visible="popupVisible"
    :drag-enabled="true"
    :hide-on-outside-click="false"
    :max-height="'100vh'"
    :min-width="500"
    :show-close-button="true"
    :show-title="true"
    height="auto"
    shading-color="rgba(0,0,0,0.05)"
    title="Загрузка фактических значений"
    width="30vw"
    @shown="setDefaultParamsValue($event)"
  >
    <dx-toolbar-item
      :options="moreInfoButtonOptions"
      locate-in-menu="always"
      toolbar="top"
      widget="dxButton"
    />
    <div class="container-fluid">
      <div class="row">
        <mped-fact-file-uploader-step :state="stepper.steps[validationStepIndex]" header="1. Настройка">
          <div class="w-100 d-flex flex-row">
            <div class="flex-grow-1 w-50">
              <span>Подразделение</span>
              <mped-department-tree-component
                :selection-mode="selectionMode"
                ref="departmentTree"
                v-model:value="filter.department"
                :default-value="-1"
                :type-department="typeDepartment"
                :validate-code="validateDepartmentCode"
                @value-changed="validateParams()" />
            </div>
            <div class="flex-grow-1 w-50">
              <span>Период</span>
              <mped-calculation-period-component
                v-model:value="filter.periods"
                :default-period="'prev'"
                :show-clear-button="false"
                :selection-mode="'single'"
                @value-changed="validateParams()" />
            </div>
          </div>
        </mped-fact-file-uploader-step>
      </div>
      <div class="row">
        <mped-fact-file-uploader-step :state="stepper.steps[chooseFileIndex]" header="2. Выбор файла">
          <div id="upload-fact-file-body">
            <input ref="inputFileUploader" class="d-none" type="file" @change="doUploadFile($event)">
            <span v-if="file?.name"> {{ file?.name }}</span>
            <dx-button
              v-if="stepper.steps[chooseFileIndex] === stateActive"
              id="upload-fact-file-button"
              :disabled="disabledUploadButton"
              type="default"
              width="100%"
              @click="uploadFile($event)"
            >
              <span class="dx-button-text">Загрузить файл</span>
            </dx-button>
            <div v-if="fileDescription">{{ fileDescription }}</div>
          </div>
        </mped-fact-file-uploader-step>
      </div>
      <div class="row">
        <mped-fact-file-uploader-step :state="stepper.steps[readFileIndex]" header="3. Чтение файла">
          <div>Количество строк: {{ rowsQuantity }}</div>
        </mped-fact-file-uploader-step>
      </div>
      <div class="row">
        <mped-fact-file-uploader-step :state="stepper.steps[uploadFileIndex]"
                                      header="4. Сохранение данных в БД">
          <dx-progress-bar
            id="progress-bar-status"
            :element-attr="{ 'aria-label': 'Progress Bar' }"
            :max="progressMaxValue"
            :min="0"
            :status-format="statusFormat"
            :value="progressValue"
            width="100%"
          />
        </mped-fact-file-uploader-step>
      </div>
      <div class="row">
        <mped-fact-file-uploader-step :state="stepper.steps[postprocessingFileIndex]"
                                      header="5. Обработка загруженных данных">
          <div v-if="stepper.steps[postprocessingFileIndex] !== stateSuccess">Обработка данных</div>
          <div v-if="stepper.steps[postprocessingFileIndex] === stateSuccess">Данные успешно загружены</div>
        </mped-fact-file-uploader-step>
      </div>

      <div class="row">
        <span v-if="stepper.errorMessage" class="text-danger"> {{ stepper.errorMessage }} </span>
        <dx-button
          v-if="stepper.errorMessage || stepper.success"
          id="reset-upload-fact-file"
          type="default"
          width="100%"
          @click="() => { validateParams() }"
        >
                        <span class="dx-button-text">
                        Повторная загрузка
                        </span>
        </dx-button>
      </div>
    </div>


  </dx-popup>
</template>

<script>
export default {
  name: 'mped-fact-file-uploader-component',
};
</script>

<script setup>
import { ref, defineExpose, computed, defineProps } from 'vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxButton } from 'devextreme-vue';
import { DxProgressBar } from 'devextreme-vue/progress-bar';

import {
  postProcessingFactFile,
  postPostprocessingFactFile,
  postPreprocessingFactFile,
  postValidationUploadParams,
} from '@/views/mped/services/mped-fact-file-service';
import MpedFactFileUploaderStep
  from '@/views/mped/components/mped-calculation-upload/mped-fact-file-uploader-step.vue';
import MpedCalculationPeriodComponent
  from '@/views/mped/views/calculation/component/mped-calculation-period-component.vue';
import MpedDepartmentTreeComponent from '@/views/mped/views/calculation/component/mped-department-tree-component.vue';
import { showLoadPanel, hideLoadPanel } from '@/components/utils/ai-global-load-panel';
import { checkErrorResponse, errorHandler } from '@/components/utils/ai-data-source-generator';
import { readDataFile } from '@/views/mped/services/mped-read-file-service';
import { getSapData } from '@/views/mped/services/mped-calculation-prepare-data-service';
import { uploadFileToStorage } from '@/service/upload-file-service';
import AiCustomConfirmDialog from '@/utils/ai-custom-confirm-dialog';

const
  validationStepIndex = 0,
  chooseFileIndex = 1,
  readFileIndex = 2,
  uploadFileIndex = 3,
  postprocessingFileIndex = 4,
  departmentTree = ref(),
  validParams = ref(false),
  filter = ref({ periods: null, department: null }),
  popupVisible = ref(false),
  inputFileUploader = ref(),
  file = ref({}),
  rowsQuantity = ref(0),
  stateActive = 'active',
  stateSuccess = 'success',
  stateError = 'error',
  progressMaxValue = ref(100),
  progressValue = ref(0),
  stepper = ref({
      success: false,
      errorMessage: '',
      currentStep: 0,
      steps: [stateActive, stateActive, stateActive, stateActive, stateActive],
      setDefaultValue: async function() {
        this.currentStep = 0;
        this.errorMessage = '';
        this.success = false;
        this.steps.fill(stateActive);
        file.value = {};
        progressMaxValue.value = 100;
        progressValue.value = 0;
        rowsQuantity.value = 0;
        inputFileUploader.value.value = null;
      },
      setNextStep(state = stateSuccess, errorMessage) {
        this.steps[this.currentStep] = state;

        if (state === stateSuccess && this.currentStep < this.steps.length) {
          this.steps[++this.currentStep] = stateActive;
        }

        if (errorMessage) {
          this.errorMessage = errorMessage;
        }
      },
    },
  );

  let
    currentProcessId = 0,
    confirmMessage,
    codes;

const { area, selectionMode, fileType, fileSchema, storage, typeDepartment, validateDepartmentCode} = defineProps({
  area: {
    type: String
  },
  fileType: {
    type: String
  },
  fileSchema: {
    type: String
  },
  storage: {
    type: Boolean,
    default: false
  },
  selectionMode: {
    type: String,
    default: 'single'
  },
  fileDescription: {
    type: String
  },
  typeDepartment: {
    type: String,
    default: 'mvp',
  },
  validateDepartmentCode: {
    type: Boolean,
    default: true
  },
});

const disabledUploadButton = computed({
  get: () => !validParams.value,
});

const moreInfoButtonOptions = {
  text: 'Инструкция',
  onClick: () => {
    const message = `Инструкция`;
  },
};

const Open = () => {
  popupVisible.value = true;
};

const setDefaultParamsValue = (e) => {
  if (!filter.value.department)
    departmentTree.value.setDefaultValue();
};

const uploadFile = async (e) => {
  if (!confirmMessage || (await AiCustomConfirmDialog(
    confirmMessage,
    'Подтверждение',
    true,
    false,
  )))
    inputFileUploader.value.click();
};

const doUploadFile = async (e) => {
  let a = 1;
  if (inputFileUploader.value?.files?.length) {
    try {
      showLoadPanel();
      file.value = inputFileUploader.value.files[0];
      stepper.value.setNextStep();
      const excelData = getSapData(await readDataFile(file.value), { ...filter.value, shift: true, area, fileName: file.value.name, codes });
      const rows = excelData.rows;
      if (rows.length === 0) {
        throw new Error('По данным настройкам не было найдено строк в файле');
      }
      await saveFileData(rows, excelData.options);
    } catch (e) {
      const errorText = errorHandler(e);
      stepper.value.setNextStep(stateError, errorText);
      if (currentProcessId) {
        await dataPostprocessing(currentProcessId, Number(filter.value.periods[0]),'ERROR', errorText);
      }
    } finally {
      hideLoadPanel();
      currentProcessId = 0;
    }
  }
};

const saveFileData = async (rows, options) => {
  stepper.value.setNextStep();
  rowsQuantity.value = rows.length;
  const saveOptions = {
    ...options,
    totalCount: rows.length,
    period: Number(filter.value.periods[0])
  };
  if (storage) {
    const fileData = await uploadFileToStorage(inputFileUploader.value.files, {
      Type: fileType,
      Schema: fileSchema,
    });
    saveOptions.storage = fileData.items[0].storage;
  }
  const preprocessingData = await dataPreprocessing(saveOptions);
  currentProcessId = preprocessingData.id;
  await saveData(rows, {...preprocessingData.options, period: saveOptions.period, processId: currentProcessId});
  await dataPostprocessing(preprocessingData.id, saveOptions.period, 'SUCCESS');
  stepper.value.success = true;
};
const dataPreprocessing = async (options) => {
  const data = await postPreprocessingFactFile({ fileName: file.value.name, ...getParamsFilterData(false), ...(options || {}) }, area);

  if (!data.success)
    throw data;

  return data;
};

const saveData = async (rows, options) => {
  const sizePortion = 1000;
  let
    portion = 1,
    fromIndex = 0,
    toIndex = 0;

  progressMaxValue.value = Math.ceil(rows.length / sizePortion);

  while (toIndex < rows.length) {
    toIndex = sizePortion * portion++;
    const portionRows = rows.slice(fromIndex, toIndex);
    const data = await postProcessingFactFile({ rows: portionRows, ...(options || {}) }, area);
    if (!data.success)
      throw data;
    fromIndex = toIndex;
    progressValue.value = progressValue.value + 1;
  }

  stepper.value.setNextStep();
};

const dataPostprocessing = async (processId, period, status, errorText = null) => {
  const data = await postPostprocessingFactFile({ processId, period, status, errorText }, area);

  if (!data.success)
    throw data;

  stepper.value.setNextStep();
};

const validateParams = async () => {
  stepper.value.setDefaultValue();
  validParams.value = false;
  if (
        (selectionMode === 'single' && (!filter.value.department || (validateDepartmentCode && !filter.value.department.mvp_code)))
        ||
        (selectionMode === 'multiple' && (!filter.value.department || !filter.value.department.length || filter.value.department.find(x => !x.mvp_code)))
        || !filter.value.periods
        || !filter.value?.periods.length)
    return;
  try {
    showLoadPanel();
    const data = await postValidationUploadParams(getParamsFilterData(), area);
    validParams.value = data.success;
    confirmMessage = data.confirmMessage;
    codes = data.codes;
    checkErrorResponse(data);
    stepper.value.setNextStep(stateSuccess);
  } catch (e) {
    stepper.value.setNextStep(stateError, errorHandler(e));
  } finally {
    hideLoadPanel();
  }
};

const getParamsFilterData = (convertPeriodToNumber = true) => {
  return {
    departmentId: selectionMode === 'single' && filter.value.department.kod_direct || filter.value.department.map(x => x.kod_direct),
    periods: convertPeriodToNumber && filter.value.periods.map(p => Number(p)) || filter.value.periods,
  };
};

const statusFormat = (ratio) => `Загрузка: ${Math.ceil(ratio * 100)}%`;

defineExpose({
  Open,
});

</script>

<style scoped>
#upload-fact-file-button {
  border-radius: 8px;
}

#upload-fact-file-button {
  height: 30px;
  width: 100%;
}
</style>
